document.addEventListener('DOMContentLoaded', function () {

  // 优化弹窗显示
  const popupObserver = new MutationObserver(() => {
    const omnisendPopup = document.querySelector('#omnisend-forms-wrapper');
    if (omnisendPopup) {
      setTimeout(function () {
        omnisendPopup.classList.add('yg-init-finished');
      }, 8000);
      popupObserver.disconnect(); // 停止观察，防止重复触发
    }
  });

  // 监听整个 body
  popupObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  // 创建 IntersectionObserver 实例
  window.YGImageLoader = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        const newImg = new Image();
        newImg.onload = () => {
          img.src = newImg.src;
          img.removeAttribute('data-src');  // 如果只需要加载一次
          img.removeAttribute('srcset');
          observer.unobserve(img);          // 停止观察该元素
        }
        newImg.src = img.getAttribute('data-src');
      }
    });
  }, {
    rootMargin: "50px", // 预加载距离视口 50px 的图片
  });

  window.YGVideoLoader = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
          // 获取内部的 template
          const template = entry.target.querySelector('template');
                
          // 将 template 的内容克隆为 DocumentFragment
          const fragment = template.content.cloneNode(true);
                
          // 先清空 yg-video 内部原有内容
          entry.target.innerHTML = '';
                
          // 将克隆的内容追加到 yg-video
          entry.target.appendChild(fragment);
      }
    });
  }, { 
    rootMargin: "200px", // 预加载距离视口 200px 的视频
  })

  class YGImage extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      // 这里放置初始化逻辑
      this.loaderImg()
    }

    get images() {
      return this.querySelectorAll('img[data-src]')
    }

    loaderImg() {
      // 这里放置自定义逻辑
      this.images.forEach((img) => {
        window.YGImageLoader.observe(img)
      })
    }
  }
  if (!window.customElements.get('yg-image')) {
    window.customElements.define('yg-image', YGImage)
  }

  class YGVideo extends HTMLElement {
    constructor() {
        super()
        this.init()
    }
    init() {
        // 这里放置初始化逻辑
        this.loaderVideo()
    }

    loaderVideo () {
        // 这里放置自定义逻辑
        window.YGVideoLoader.observe(this)
    }
  }
  if (!window.customElements.get('yg-video')) {
      window.customElements.define('yg-video', YGVideo)
  }

  class YGPopupBox extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (e) => {
        this.closePopup(e, () => { });
      });
    }

    openPopup($popupTemplate, fn) {
      // popupTemplate：需要替换的元素
      this.querySelector('.yg-popup-box-content-inner').innerHTML = $popupTemplate.innerHTML;
      document.querySelector('body').style.overflow = 'hidden';
      this.style.display = 'flex';
      fn();
    }
    closePopup(e, fn) {
      if (e.target.className == 'yg-popup-box-close' || e.target.className == 'yg-popup-box') {
        this.style.display = 'none';
        this.querySelector('.yg-popup-box-content-inner').innerHTML = '';
        document.querySelector('body').style.overflow = 'auto';
        fn();
      }
    }
  }
  if (!window.customElements.get('yg-popup-box')) {
    window.customElements.define('yg-popup-box', YGPopupBox);
  }

  class YGOpenPopup extends HTMLElement {
    constructor() {
      super();
      this.init();
      this.$popupBox = document.querySelector('yg-popup-box.yg-popup-box');
    }
    init() {
      // 这里放置初始化逻辑
      this.addEventListener('click', this.itemClick.bind(this));
    }
    itemClick() {
      // 这里放置自定义逻辑
      let $popupTemplate = this.querySelector('template') || this.querySelector('.yg-popup-template');

      $popupTemplate && this.$popupBox.openPopup($popupTemplate, () => { });

    }
  }
  if (!window.customElements.get('yg-open-popup')) {
    window.customElements.define('yg-open-popup', YGOpenPopup);
  }

  class YGDeferredMedia extends HTMLElement {
    constructor() {
      super();
    }

    static get observedAttributes() {
      return ['playing'];
    }

    connectedCallback() {
      this.bindPosterButton();

      this.addEventListener('click', (e) => {
        const video = this.querySelector('video')
        if (
          video &&
          e.target === video &&
          !video.hasAttribute('controls')
        ) {
          e.preventDefault()
          e.stopPropagation()
          if (this.playing) {
            this.pause()
          } else {
            this.play()
          }
        }
      });

      if (this.autoplay) {
        this.inViewObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.init();
            }
          });
        });
        this.inViewObserver.observe(this);
      }
    }

    get posterElement() {
      return this.querySelector('[id^="YG-DeferredPoster-"]');
    }

    get autoplay() {
      return this.hasAttribute('autoplay');
    }

    get playing() {
      return this.hasAttribute('playing');
    }

    get player() {
      return this.playerProxy = this.playerProxy || new Proxy(this.playerTarget(), {
        get: (target, prop) => {
          return async () => {
            target = await target;
            this.playerHandler(target, prop);
          };
        }
      });
    }

    bindPosterButton() {
      const poster = this.posterElement;
      if (poster && !poster.hasListener) {
        poster.addEventListener('click', this.onPosterClick.bind(this));
        poster.hasListener = true;
      }
    }

    async playerTarget() {
      const template = this.querySelector('template');
      if (!template) return Promise.resolve(null);

      if (!this.mediaElement) {
        const fragment = template.content.cloneNode(true);
        this.appendChild(fragment);
        this.mediaElement = this.querySelector('video, iframe');
      }

      this.bindPosterButton();
      return Promise.resolve(this.mediaElement);
    }

    playerHandler(target, prop) {
      if (!target) return;

      if (prop === 'play' && typeof target.play === 'function') {
        target.play();
        this.setAttribute('playing', '');
        this.removeAttribute('paused');
      }

      if (prop === 'pause' && typeof target.pause === 'function') {
        target.pause();
        this.removeAttribute('playing');
        this.setAttribute('paused', '');
      }
    }

    onPosterClick(event) {
      event.preventDefault();
      event.stopPropagation();

      if (this.playing) {
        this.pause();
      } else {
        this.play();
      }
    }

    init() {
      if (!this.paused) {
        this.play();
      }
      return () => this.pause();
    }

    play() {
      if (!this.playing) {
        this.player.play();
      }
    }

    pause() {
      if (this.playing) {
        this.player.pause();
      }
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'playing') {
        if (oldValue === null && newValue === '') {
          this.dispatchEvent(new CustomEvent('video:play', { bubbles: true }));
          this.removeAttribute('paused');
        }
        if (newValue === null) {
          this.dispatchEvent(new CustomEvent('video:pause', { bubbles: true }));
          this.setAttribute('paused', '');
        }
      }
    }
  }

  class YGMedia extends YGDeferredMedia {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback(); // 保留父类逻辑

      if (!this.querySelector('img') && !this.hasAttribute('autoplay')) {
        this.inViewObserverNoAutoplay = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.loadMediaOnly();
              this.inViewObserverNoAutoplay.disconnect();
            }
          });
        });
        this.inViewObserverNoAutoplay.observe(this);
      }
    }

    async loadMediaOnly() {
      if (!this.mediaElement) {
        const template = this.querySelector('template');
        if (template) {
          const fragment = template.content.cloneNode(true);
          this.appendChild(fragment);
          this.mediaElement = this.querySelector('video, iframe');
          this.setAttribute('loaded', '');
          this.closest('.media')?.classList.remove('loading');
          this.bindPosterButton();
        }
      }
    }

    async playerTarget() {
      if (this.hasAttribute('host')) {
        this.setAttribute('loaded', '');
        this.closest('.media')?.classList.remove('loading');

        return new Promise(async (resolve) => {
          const templateElement = this.querySelector('template');
          if (templateElement) {
            templateElement.replaceWith(templateElement.content.firstElementChild.cloneNode(true));
          }
          this.bindPosterButton();

          const muteVideo = this.hasAttribute('autoplay') || window.matchMedia('(max-width: 1023px)').matches;
          const host = this.getAttribute('host');

          if (host === 'youtube') {
            if (!window.YT || !window.YT.Player) {
              await new Promise(res => {
                const script = document.createElement('script');
                script.src = 'https://www.youtube.com/iframe_api';
                script.onload = res;
                document.head.appendChild(script);
              });
              await new Promise(res => {
                window.onYouTubeIframeAPIReady = res;
              });
            }

            const player = new YT.Player(this.querySelector('iframe'), {
              events: {
                onReady: () => {
                  if (muteVideo) player.mute();
                  resolve(player);
                },
                onStateChange: (event) => {
                  if (event.data === YT.PlayerState.PLAYING) {
                    this.setAttribute('playing', '');
                    this.removeAttribute('paused');
                  }
                  if (event.data === YT.PlayerState.PAUSED || event.data === YT.PlayerState.ENDED) {
                    this.removeAttribute('playing');
                    this.setAttribute('paused', '');
                  }
                }
              }
            });
          }

          if (host === 'vimeo') {
            if (!window.Vimeo || !window.Vimeo.Player) {
              await new Promise(res => {
                const script = document.createElement('script');
                script.src = 'https://player.vimeo.com/api/player.js';
                script.onload = res;
                document.head.appendChild(script);
              });
            }

            const player = new Vimeo.Player(this.querySelector('iframe'));
            if (muteVideo) await player.setMuted(true);

            player.on('play', () => {
              this.setAttribute('playing', '');
              this.removeAttribute('paused');
            });
            player.on('pause', () => {
              this.removeAttribute('playing');
              this.setAttribute('paused', '');
            });
            player.on('ended', () => {
              this.removeAttribute('playing');
              this.setAttribute('paused', '');
            });

            resolve(player);
          }

          if (host === 'pimmedia') {
            // 假设 pimmedia 的 iframe 已经在页面上
            const iframe = this.querySelector('iframe');
            console.log("第三季我")
            if (!iframe) {
              console.warn('pimmedia iframe not found');
              return;
            }

            // 假设 mute 需要 postMessage 或类似接口，这里根据你具体接口改写
            if (muteVideo) {
              // 这里看你的 pimmedia 播放器怎么静音，比如 postMessage
              iframe.contentWindow.postMessage({ action: 'mute' }, '*');
            }

            // 监听 pimmedia 的消息事件（例如播放、暂停、结束）
            window.addEventListener('message', (event) => {
              // 确认是 pimmedia 的消息，可根据 event.origin 做验证
              const data = event.data;

              if (typeof data !== 'object' || !data.event) return;

              if (data.event === 'play') {
                this.setAttribute('playing', '');
                this.removeAttribute('paused');
              }
              if (data.event === 'pause' || data.event === 'ended') {
                this.removeAttribute('playing');
                this.setAttribute('paused', '');
              }
            });

            // 返回一个模拟的 player 对象给 resolve
            resolve({
              play() {
                iframe.contentWindow.postMessage({ action: 'play' }, '*');
              },
              pause() {
                iframe.contentWindow.postMessage({ action: 'pause' }, '*');
              },
              mute() {
                iframe.contentWindow.postMessage({ action: 'mute' }, '*');
              }
            });
          }
        });
      } else {
        const templateElement = this.querySelector('template');
        if (templateElement) {
          templateElement.replaceWith(templateElement.content.firstElementChild.cloneNode(true));
        }
        this.setAttribute('loaded', '');
        this.closest('.media')?.classList.remove('loading');

        const player = this.querySelector('video');
        player.addEventListener('play', () => {
          this.setAttribute('playing', '');
          this.removeAttribute('paused');
          this.removeAttribute('suspended');
        });
        player.addEventListener('pause', () => {
          if (!player.seeking && player.paused) {
            this.removeAttribute('playing');
            this.setAttribute('paused', '');
          }
        });

        this.bindPosterButton();
        return player;
      }
    }

    playerHandler(target, prop) {
      const host = this.getAttribute('host');

      if (host === 'youtube') {
        if (prop === 'play') {
          target.playVideo();
          this.setAttribute('playing', '');
          this.removeAttribute('paused');
        } else {
          target.pauseVideo();
          this.removeAttribute('playing');
          this.setAttribute('paused', '');
        }
      } else if (host === 'vimeo') {
        if (prop === 'play') {
          target.play();
          this.setAttribute('playing', '');
          this.removeAttribute('paused');
        } else {
          target.pause();
          this.removeAttribute('playing');
          this.setAttribute('paused', '');
        }
      } else {
        if (prop === 'play') {
          target.play().catch((error) => {
            if (error.name === 'NotAllowedError') {
              this.setAttribute('suspended', '');
              target.controls = true;
              const replacementImageSrc = target.previousElementSibling?.currentSrc;
              if (replacementImageSrc) {
                target.poster = replacementImageSrc;
              }
            }
          });
          this.setAttribute('playing', '');
          this.removeAttribute('paused');
        } else {
          target.pause();
          this.removeAttribute('playing');
          this.setAttribute('paused', '');
        }
      }
    }
  }

  if (!customElements.get('yg-video')) {
    customElements.define('yg-video', YGMedia);
  }

  class YGSwiper extends HTMLElement {
    constructor() {
      super()
    }
    connectedCallback() {
      this.getAllAttributes()
      this.initSwiper()
    }

    getAllAttributes() {
      let booleanAttrs = ['loop', 'pagination', 'navigation'];
      let jsonAttrs = ['breakpoints']
      for (const attr of this.attributes) {
        if (attr.name.startsWith('data-')) {
          const cleanName = attr.name.slice(5); // 去除 'data-' 前缀

          let value = attr.value;
          if (booleanAttrs.includes(cleanName)) {
            value = value === 'true';
          } else if (jsonAttrs.includes(cleanName)) {
            value = this.parseSwiperBreakpoints(value);
          }

          this[cleanName] = value;
        }
      }
    }

    parseSwiperBreakpoints(str) {
      const result = {};
      const pairs = str.split(',');

      console.log("pairs", pairs)
      for (const pair of pairs) {
        const [breakpoint, values] = pair.split(':');
        if (!breakpoint || !values) continue;

        const [slides, space] = values.split('-').map(Number);

        result[breakpoint.trim()] = {
          slidesPerView: slides,
          spaceBetween: space
        };
      }

      console.log("result", result)
      return result;
    }

    initSwiper() {
      const swiper = new Swiper(this, {
        // 这里放置 swiper 的配置
        loop: this['loop'],
        autoplay: this['autoplay'] ? {
          delay: this['autoplay'],
          stopOnLastSlide: false,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        } : false,
        pagination: this['pagination'] ? {
          el: '.swiper-pagination',
          clickable: true,
        } : false,
        navigation: this['navigation'] ? {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        } : false,
        breakpoints: this['breakpoints'] ? this['breakpoints'] : false
      })
    }
  }
  if (!window.customElements.get('yg-swiper')) {
    window.customElements.define('yg-swiper', YGSwiper)
  }

  class YGMegaMenuProduct extends HTMLElement {
    constructor() {
      super()

      this.tabItems = this.querySelectorAll('.yg-mega-menu-tab');
      this.contentItems = this.querySelectorAll('.yg-mega-menu-content');
      this.itemMouseenter = this.itemMouseenter.bind(this);
    }
    connectedCallback() {
      this.tabItems.forEach((item, i) => {
        item.addEventListener('mouseenter', () => this.itemMouseenter(item, i));
      })
    }
    disconnectedCallback() {
      this.tabItems.forEach(item => {
        item.removeEventListener('mouseenter', this.itemMouseenter);
      })
    }
    itemMouseenter(item, i) {
      this.tabItems.forEach(i => i.classList.remove('active'));
      this.contentItems.forEach(i => i.classList.remove('active'));
      item.classList.add('active');
      this.contentItems[i].classList.add('active');
    }
  }
  if (!window.customElements.get('yg-mega-menu-product')) {
    window.customElements.define('yg-mega-menu-product', YGMegaMenuProduct)
  }


  class YGCollapseTrigger extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.initializeFaqItems();
      this.initializeContentState();
      this.addEventListeners();
    }

    initializeFaqItems() {
      this.faqItems = this.querySelectorAll('.yg-collapse-item');
    }

    initializeContentState() {
      this.faqItems.forEach((item) => {
        const $desc = item.querySelector('.yg-collapse-item-desc');
        const $button = item.querySelector('.yg-toggle-btn');

        if ($desc) {
          // 设置初始状态为收起（显示4行）
          $desc.classList.add('collapsed');

          // 检查是否需要显示按钮
          this.checkIfNeedsToggle(item, $button);
        }
      });
    }

    checkIfNeedsToggle(faqElement, toggleButton) {
      const $desc = faqElement.querySelector('.yg-collapse-item-desc');
      const $content = $desc.querySelector('.prose');

      // 临时移除省略样式来测量真实高度
      $desc.classList.remove('collapsed');
      const fullHeight = $content.scrollHeight;

      // 重新应用省略样式
      $desc.classList.add('collapsed');
      const collapsedHeight = $desc.scrollHeight;

      // 如果内容超过4行，显示展开按钮；否则隐藏按钮
      if (fullHeight > collapsedHeight) {
        if (toggleButton) {
          toggleButton.style.display = 'flex';
        }
      } else {
        if (toggleButton) {
          toggleButton.style.display = 'none';
        }
      }
    }

    addEventListeners() {
      this.addEventListener('click', (e) => {
        if (e.target.closest('.yg-toggle-btn')) {
          const faqElement = e.target.closest('.yg-collapse-item');
          this.toggleFaq(faqElement);
        }
      });
    }

    toggleFaq(faqElement) {
      const $desc = faqElement.querySelector('.yg-collapse-item-desc');
      const $button = faqElement.querySelector('.yg-toggle-btn');
      const $svg = $button?.querySelector('svg');
      const isExpanded = faqElement.classList.contains('expanded');

      if (isExpanded) {
        // 收起
        faqElement.classList.remove('expanded');
        $desc.classList.add('collapsed');

        // 重置 SVG 旋转
        if ($svg) {
          $svg.style.transform = 'rotate(0deg)';
        }
      } else {
        // 展开
        faqElement.classList.add('expanded');
        $desc.classList.remove('collapsed');

        // 旋转 SVG
        if ($svg) {
          $svg.style.transform = 'rotate(180deg)';
        }
      }
    }
  }


  if (!window.customElements.get('yg-collapse-trigger')) {
    customElements.define('yg-collapse-trigger', YGCollapseTrigger);
  }
  class YGScrollSwitch extends HTMLElement {
  constructor() {
    super();
    this._swiper = null; 
  }
  get indicatorSwiper (){
    let indicator = this.querySelector('.yg-switch-indicator');

    return new Swiper(indicator, {
      slidesPerView: 'auto',
      noSwiping: true,
      direction: 'vertical',
    })
  }

  get swiper() {
    if (!this._swiper) {
      const swiperEl = this.querySelector('.yg-scroll-switch');
      this._swiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        noSwiping: true,
        direction: 'vertical',
        thumbs: {
          swiper: this.indicatorSwiper,
        }
      });
    }
    return this._swiper;
  }

  get titleBox() {
    return this.querySelectorAll('.yg-title-box')
  }

  connectedCallback() {
  const swiper = this.swiper;


  this.querySelectorAll('.yg-info-card').forEach((card) => {
    const index = parseInt(card.getAttribute('data-index'), 10);
    if (!isNaN(index)) {
      card.addEventListener('click', () => {
        swiper.slideTo(index);
      });
    }
  });
  setTimeout(() => {
      this.registerAnimations()
    }, 4000)
  }

  registerAnimations() {
    gsap.registerPlugin(ScrollTrigger);
  
    const totalSlides = this.swiper.slides.length;
  
    gsap.to(this, {
      scrollTrigger: {
        trigger: this.querySelector('.yg-section-main'),
        start: "top top",
        end: `+=${200 * totalSlides}`,
        pin: true,
        scrub: 1,
        snap: 1 / (totalSlides - 1),
        onUpdate: (self) => {
          const index = Math.round(self.progress * (totalSlides - 1));
          if (this.swiper.activeIndex !== index) {
          this.swiper.slideTo(index, 400);
        }

        if (index === 0) {
          this.swiper.setTranslate(index);
        }

          this.titleBox.forEach((title, i) => {
            title.style.transform = `translateX(${(index) * -100}%)`
          })
        },
      }
    });
  }
}

if (!window.customElements.get('yg-scroll-switch')) {
  window.customElements.define('yg-scroll-switch', YGScrollSwitch);
}

  class YGCardButtons extends HTMLElement {
    constructor() {
      super()
      this.addToCart()
      this.buyItNow()
    }

    addToCart() {
      const AddBtn = this.querySelector('.yg-old-buttons button[type="submit"]')
      this.querySelector('.yg-add-to-cart').addEventListener("click", (e) => {
        // 检查是否存在批量购买数据
        if (YGBulkPurchase.productData && YGBulkPurchase.productData.length > 0) {
          e.preventDefault(); // 阻止默认行为
          this.handleBulkAddToCart();
        } else {
          // 执行原有的单品加购逻辑
          AddBtn.click();
        }
        // // Add to cart logic
        // AddBtn.click();
      });
    }

    // 获取当前产品的信息
    getCurrentProductData() {
      const form = document.querySelector('[data-product-form]') || document.querySelector('form[action*="/cart/add"]');
      if (form) {
        const variantId = form.querySelector('input[name="id"]')?.value;
        const quantity = form.querySelector('input[name="quantity"]')?.value || 1;

        if (variantId) {
          return {
            id: variantId,
            quantity: parseInt(quantity)
          };
        }
      }
      return null;
    }

    // 捆绑购买
    handleBulkAddToCart() {
      let sectionsToBundle = ["variant-added"];
      document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle }
      }));

      // 合并当前产品和批量购买产品
      let allItems = [...YGBulkPurchase.productData];

      // 添加当前产品到购物车项目中
      const currentProduct = this.getCurrentProductData();
      if (currentProduct) {
        allItems.push(currentProduct);
      }

      let formData = {
        'items': allItems,
        'sections': sectionsToBundle.join(",")
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then(async response => {
          if (response.ok) {
            const responseJson = await response.json();
            if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
              return window.location.href = `${Shopify.routes.root}cart`;
            }
            const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
            cartContent["sections"] = responseJson["sections"];

            this.dispatchEvent(new CustomEvent("variant:add", {
              bubbles: true,
              detail: {
                items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
                cart: cartContent
              }
            }));
            document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
              bubbles: true,
              detail: {
                baseEvent: "variant:add",
                cart: cartContent
              }
            }));
          } else {
            const responseJson = await response.json();
            this.dispatchEvent(new CustomEvent("yg_cart:error", {
              bubbles: true,
              detail: {
                error: responseJson["description"]
              }
            }));
            document.dispatchEvent(new CustomEvent("cart:refresh"));
          }
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }

    buyItNow() {
      this.querySelector('.yg-buy-it-now').addEventListener("click", () => {
        let buyBtn = this.querySelector('.yg-old-buttons .shopify-payment-button .shopify-payment-button__more-options');
        buyBtn.click();
      })
    }
  }

  if (!window.customElements.get('yg-card-buttons')) {
    window.customElements.define('yg-card-buttons', YGCardButtons)
  }

  class YGBulkPurchase extends HTMLElement {
    static productData = []

    constructor() {
      super()
      this.init()
    }

    init() {
      this.taggledClass()
      this.totalPrices()
      // this.addToCart()
    }

    taggledClass() {
      this.querySelectorAll('.yg-bulk-purchase__product').forEach(item => {
        item.addEventListener('click', (e) => {
          if (e.target.classList.contains('quantity-selector__button') ||
            e.target.classList.contains('quantity-selector__input') ||
            e.target.closest('.quantity-selector__button')) {
            return
          }
          item.classList.toggle('active')
          item.parentNode.parentNode.classList.toggle('active')
          this.totalPrices()
        })
      })

      // 监听数量输入框变化
      this.querySelectorAll('.quantity-selector__input').forEach(quantity => {
        quantity.addEventListener('input', (e) => {
          // 确保输入值为正整数
          let value = parseInt(e.target.value) || 1;
          if (value < 1) value = 1;
          e.target.value = value;
          this.totalPrices()
        })
      })

      // 监听数量按钮点击
      this.querySelectorAll('.quantity-selector__button').forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          const quantityInput = button.parentElement.querySelector('.quantity-selector__input');
          let currentValue = parseInt(quantityInput.value) || 1;

          // 检查是减少还是增加按钮
          const isDecrease = button.querySelector('path[d*="20.4049 15.4399H11.4398"]') !== null;

          if (isDecrease) {
            // 减少数量，最小值为1
            if (currentValue > 1) {
              quantityInput.value = currentValue - 1;
            }
          } else {
            // 增加数量
            quantityInput.value = currentValue + 1;
          }

          // 触发input事件以更新总价
          quantityInput.dispatchEvent(new Event('input'));
          this.totalPrices()
        })
      })
    }


    // taggledClass() {
    //   this.querySelectorAll('.yg-bulk-purchase__product').forEach(item => {
    //     item.addEventListener('click', (e) => {
    //       if (e.target.classList.contains('quantity-selector__button') || e.target.classList.contains('quantity-selector__input')) {
    //         return
    //       }
    //       item.classList.toggle('active')
    //       item.parentNode.parentNode.classList.toggle('active')
    //       this.totalPrices()
    //     })
    //   })
    //   this.querySelectorAll('.quantity-selector__input').forEach(quantity => {
    //     quantity.addEventListener('input', (e) => {
    //       this.totalPrices()
    //     })
    //   })
    //   this.querySelectorAll('.quantity-selector__button').forEach(button => {
    //     button.addEventListener('click', (e) => {
    //       this.totalPrices()
    //     })
    //   })

    // }

    totalPrices() {
      let activeProducts = this.querySelectorAll('.yg-bulk-purchase__product.active')
      let totalPrice = 0
      YGBulkPurchase.productData = []

      activeProducts.forEach(active => {
        let productPriceBox = active.querySelector('.yg-bulk-purchase__product-price').getAttribute('data-price')
        let productQuantity = active.querySelector('.quantity-selector__input').value
        totalPrice += parseInt(productPriceBox) * parseInt(productQuantity)

        YGBulkPurchase.productData.push({
          'id': active.querySelector('.yg-bulk-purchase__product-price').getAttribute('data-id'),
          'quantity': productQuantity
        })
      })

      let totalPriceBox = this.querySelector('.yg-tatal-price__price')
      let currencyFormat = totalPriceBox.getAttribute('data-currency')

      // 改进货币格式解析
      let currencySymbol = '$' // 默认美元符号
      let currencyCode = 'USD' // 默认货币代码

      // 从原始格式中提取货币信息
      if (currencyFormat) {
        // 匹配货币代码（通常是3个字母）
        const codeMatch = currencyFormat.match(/[A-Z]{3}/)
        if (codeMatch) {
          currencyCode = codeMatch[0]
        }

        // 匹配货币符号
        const symbolMatch = currencyFormat.match(/[$£€¥]/)
        if (symbolMatch) {
          currencySymbol = symbolMatch[0]
        }
      }

      // 格式化总价
      const formattedPrice = (totalPrice / 100).toFixed(2)
      totalPriceBox.innerHTML = `${currencyCode} ${currencySymbol} ${formattedPrice}`
    }


    // addToCart() {
    //   this.querySelector('.yg-add-to-cart').addEventListener('click', (e) => {
    //     let sectionsToBundle = ["variant-added"];
    //     document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", {
    //       bubbles: true,
    //       detail: { sections: sectionsToBundle }
    //     }));
    //     let formData = {
    //       'items': YGBulkPurchase.productData,
    //       'sections': sectionsToBundle.join(",")
    //     };
    //     fetch(window.Shopify.routes.root + 'cart/add.js', {
    //       method: 'POST',
    //       headers: {
    //         'Content-Type': 'application/json'
    //       },
    //       body: JSON.stringify(formData)
    //     })
    //       .then(async response => {
    //         if (response.ok) {
    //           const responseJson = await response.json();
    //           if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
    //             return window.location.href = `${Shopify.routes.root}cart`;
    //           }
    //           const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
    //           cartContent["sections"] = responseJson["sections"];

    //           this.dispatchEvent(new CustomEvent("variant:add", {
    //             bubbles: true,
    //             detail: {
    //               items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
    //               cart: cartContent
    //             }
    //           }));
    //           document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
    //             bubbles: true,
    //             detail: {
    //               baseEvent: "variant:add",
    //               cart: cartContent
    //             }
    //           }));
    //         } else {
    //           const responseJson = await response.json();

    //           this.dispatchEvent(new CustomEvent("yg_cart:error", {
    //             bubbles: true,
    //             detail: {
    //               error: responseJson["description"]
    //             }
    //           }));
    //           document.dispatchEvent(new CustomEvent("cart:refresh"));
    //         }
    //       })
    //       .catch((error) => {
    //         console.error('Error:', error);
    //       });
    //   })
    // }
  }

  if (!window.customElements.get('yg-bulk-purchase')) {
    window.customElements.define('yg-bulk-purchase', YGBulkPurchase)
  }

})

!function(){let e=e=>!function e(t){if(t.length%4!=0||!/^[A-Za-z0-9+/=]+$/.test(t))return!1;try{return atob(t),!0}catch(r){return!1}}(e)?e:decodeURIComponent(escape(window.atob(e))),t={is_mark:"F",shop_domain:window?.Shopify?.shop||"",watermark_text:e("5rC05Y2w5paH5pys"),watermark_size:"20px",watermark_color:"#333333"},r=`${e("aHR0cHM6Ly9haXMueWlndW90ZWNoLmNvbS9zaXRlbWFyay9wcm90ZWN0aW9uL2FwaS92MS93YXRlcm1hcms=")}?shop_domain=${t.shop_domain}`,i=()=>{fetch(r).then(e=>{e.json().then(e=>{"success"===e.result&&(t={...t,...e,expire_time:Date.now()+864e5},"T"===e.is_mark&&n(t),localStorage.setItem("sitemark_watermark",JSON.stringify(t)))})})},s=null,n=e=>{if(s){s.disconnect();return}let{watermark_text:t,watermark_size:r,watermark_color:i}=e,o=document.createElement("div");o.style.position="absolute",o.style.zIndex="9999",o.style.left="50%",o.style.bottom="0",o.style.fontSize=r,o.style.color=i,o.innerHTML=t,setTimeout(()=>{let t=document.querySelector("footer");t?(t.style.position="relative",t.appendChild(o),(s=new MutationObserver(t=>{s.disconnect(),s=null,n(e)})).observe(t,{attributes:!0,childList:!0,subtree:!0})):(o.style.position="fixed",document.body.appendChild(o))},1e3)},o=localStorage.getItem("sitemark_watermark");if(o){let a=JSON.parse(o);t={...t,...a},a.expire_time&&a.expire_time<Date.now()?i():"T"===a.is_mark&&n(t)}else i()}();